/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signuplist1Inputs */

const en_signuplist1 = /** @type {(inputs: Signuplist1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign-ups`)
};

const de_signuplist1 = /** @type {(inputs: Signuplist1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmeldungen`)
};

/**
* | output |
* | --- |
* | "Sign-ups" |
*
* @param {Signuplist1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signuplist1 = /** @type {((inputs?: Signuplist1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signuplist1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signuplist1(inputs)
	return de_signuplist1(inputs)
});
export { signuplist1 as "signupList" }